// Copyright 2025 - Hewlett Packard Enterprise Company
import { useTheme } from 'styled-components';
import { useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Text } from 'grommet';
import { normalizeColor } from 'grommet/utils';

const STATUS_INTERVAL = 5000;

const MessageLoader = () => {
  const { t } = useTranslation('common');
  const statusMessages = useMemo(
    () => [
      t('chat.status.analyzing'),
      t('chat.status.retrieving'),
      t('chat.status.processing'),
      t('chat.status.generating'),
      t('chat.status.verifying'),
    ],
    [t],
  );
  const [currentStatus, setCurrentStatus] = useState(statusMessages[0]);

  useEffect(() => {
    let currentIndex = 0;
    const interval = setInterval(() => {
      if (currentIndex < statusMessages.length - 1) {
        currentIndex++;
        setCurrentStatus(statusMessages[currentIndex]);
      }
    }, STATUS_INTERVAL);

    return () => clearInterval(interval);
  }, [statusMessages]);

  return (
    <Box
      width="medium"
      height="xxsmall"
      margin={{ bottom: 'xsmall' }}
      direction="row"
      gap="small"
    >
      <Text style={{ whiteSpace: 'nowrap', minWidth: 'fit-content' }}>
        {currentStatus}
      </Text>
      <svg>
        <ThinkCircle cx="6" begin="0s" />
        <ThinkCircle cx="22" begin="-1.1s" />
        <ThinkCircle cx="38" begin="-0.9s" />
      </svg>
    </Box>
  );
};

const ThinkCircle = ({ cx, begin }) => {
  const theme = useTheme();
  const brandGreen = normalizeColor('brand', theme);

  return (
    <circle cx={cx} cy="6" r="5" fill={brandGreen}>
      <animate
        attributeName="cy"
        from="15"
        to="5"
        dur="1.4s"
        begin={begin}
        values="15;5;15;15"
        repeatCount="indefinite"
      />
      <animate
        attributeName="opacity"
        from="0.5"
        to="1"
        dur="1.4s"
        begin={begin}
        values="0.5;1;0.5;0.5"
        repeatCount="indefinite"
      />
    </circle>
  );
};
export default MessageLoader;
